import React from 'react';
import { Filter, X } from 'lucide-react';

const CURRENCIES = ['', 'RSD', 'EUR', 'USD', 'CHF', 'GBP'];
const OFFER_TYPES = [
  { value: '', label: 'Svi tipovi' },
  { value: 'kupovina', label: 'Kupovina' },
  { value: 'prodaja', label: 'Prodaja' },
];
const CATEGORIES = [
  { value: '', label: 'Sve kategorije' },
  { value: 'consulting_service', label: 'Consulting Service' },
  { value: 'healthcare_wellness', label: 'Healthcare & Wellness' },
  { value: 'hospitality_services', label: 'Hospitality Services' },
  { value: 'products_goods', label: 'Products & Goods' },
  { value: 'professional_services', label: 'Professional Services' },
  { value: 'rental_leasing', label: 'Rental & Leasing' },
  { value: 'training_education', label: 'Training & Education' },
  { value: 'other', label: 'Other' },
];
const SORT_OPTIONS = [
  { value: 'newest', label: 'Najnoviji' },
  { value: 'oldest', label: 'Najstariji' },
  { value: 'price_asc', label: 'Cena: rastuće' },
  { value: 'price_desc', label: 'Cena: opadajuće' },
  { value: 'qty_desc', label: 'Količina: najveća' },
];

export default function FilterPanel({ filters, onFiltersChange, sortBy, onSortChange }) {
  const hasActiveFilters = filters?.wishType || filters?.currency || filters?.minPrice || filters?.maxPrice || filters?.category;

  const clearFilters = () => {
    onFiltersChange({ wishType: '', currency: '', minPrice: '', maxPrice: '', category: '' });
  };

  const update = (key, value) => {
    onFiltersChange({ ...filters, [key]: value });
  };

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-4 space-y-5">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-gray-700 font-medium">
          <Filter size={16} />
          Filteri
        </div>
        {hasActiveFilters && (
          <button onClick={clearFilters} className="flex items-center gap-1 text-xs text-red-500 hover:text-red-700 min-h-[44px] px-2">
            <X size={12} /> Obriši
          </button>
        )}
      </div>
      {/* Tip oglasa */}
      <div>
        <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide mb-2">Tip oglasa</label>
        <select
          value={filters?.wishType}
          onChange={(e) => update('wishType', e?.target?.value)}
          className="w-full px-3 py-2.5 min-h-[44px] border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 bg-white"
        >
          {OFFER_TYPES?.map(t => (
            <option key={t?.value} value={t?.value}>{t?.label}</option>
          ))}
        </select>
      </div>
      {/* Kategorija */}
      <div>
        <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide mb-2">Kategorija</label>
        <select
          value={filters?.category}
          onChange={(e) => update('category', e?.target?.value)}
          className="w-full px-3 py-2.5 min-h-[44px] border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 bg-white"
        >
          {CATEGORIES?.map(c => (
            <option key={c?.value} value={c?.value}>{c?.label}</option>
          ))}
        </select>
      </div>
      {/* Valuta */}
      <div>
        <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide mb-2">Valuta</label>
        <select
          value={filters?.currency}
          onChange={(e) => update('currency', e?.target?.value)}
          className="w-full px-3 py-2.5 min-h-[44px] border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 bg-white"
        >
          {CURRENCIES?.map(c => (
            <option key={c} value={c}>{c || 'Sve valute'}</option>
          ))}
        </select>
      </div>
      {/* Cenovni rang */}
      <div>
        <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide mb-2">Cenovni rang</label>
        <div className="flex gap-2">
          <input
            type="number"
            min="0"
            value={filters?.minPrice}
            onChange={(e) => update('minPrice', e?.target?.value)}
            placeholder="Min"
            className="w-full px-2 py-2.5 min-h-[44px] border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
          />
          <input
            type="number"
            min="0"
            value={filters?.maxPrice}
            onChange={(e) => update('maxPrice', e?.target?.value)}
            placeholder="Max"
            className="w-full px-2 py-2.5 min-h-[44px] border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
          />
        </div>
      </div>
      {/* Sortiranje */}
      <div>
        <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide mb-2">Sortiraj po</label>
        <select
          value={sortBy}
          onChange={(e) => onSortChange(e?.target?.value)}
          className="w-full px-3 py-2.5 min-h-[44px] border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 bg-white"
        >
          {SORT_OPTIONS?.map(o => (
            <option key={o?.value} value={o?.value}>{o?.label}</option>
          ))}
        </select>
      </div>
    </div>
  );
}
